<template>
	<div id="ezuikitref" class="ezuikit">
		<div id="video-container" />
	</div>
</template>

<script lang="js">
	import EZUIKit from "ezuikit-js";
	import {
		defineComponent,
		onBeforeUnmount,
		onMounted,
		ref,
		watch
	} from "vue";
	import mitt from '@/utils/bus.js';

	let player;
	let accessToken;
	let timer; // Define the timer variable

	export default defineComponent({
		props: {
			msg: String,
			equipmentNo: String,
			ysyw: Number,
			ysyh: Number,
			equipmentRoute: Number
		},
		setup(props) {
			const startTimer = () => {
				// Clear any existing timer
				clearTimeout(timer);
				// Start a new timer
				timer = setTimeout(() => {
					if (player) {
						player.stop().then((data) => {
							console.log(
								"Video stopped automatically after 15 seconds",
								data);
						});
					}
				}, 30000); // 15 seconds
			};

			onMounted(() => {
				mitt.on('Gettoken', (data) => {
					accessToken = data.accessToken;
					player = new EZUIKit.EZUIKitPlayer({
						id: 'video-container', // 视频容器ID
						accessToken: accessToken,
						url: `ezopen://open.ys7.com/${props.equipmentNo}/${props.equipmentRoute}.hd.live`,
						template: 'pcLive',
						width: props.ysyw,
						height: props.ysyh,
						plugin: ['fullScreen'],
						enable3D: true,
						footer: ['fullScreen']
					});
					startTimer(); // Start the timer when the player is initialized
				});
			});

			watch(() => props.equipmentNo, (newvalue) => {
				if (player != null) {
					player.stop()
						.then(() => {
							player.play({
								url: `ezopen://open.ys7.com/${newvalue}/${props.equipmentRoute}.hd.live`,
								accessToken
							});
							startTimer(); // Restart the timer when the equipmentNo changes
						});
				}
			});

			onBeforeUnmount(() => {
				if (player) {
					player.stop().then((data) => {
						console.log("promise 获取 数据", data);
					});
				}
				mitt.off('Gettoken');
				// Clear the timer when the component is unmounted
				clearTimeout(timer);
			});
		}
	});
</script>

<style lang="scss">
</style>
